import { Link } from 'react-router-dom';

import { Button, Icon, LoadingSpinner } from '@kanda-libs/ks-design-library';

interface ButtonWrapperProps {
  link?: string;
  children?: string | JSX.Element | JSX.Element[];
}

const ButtonWrapper = ({ children, link }: ButtonWrapperProps) => (
  <>{link ? <Link to={link}>{children}</Link> : children}</>
);

ButtonWrapper.defaultProps = {
  link: null,
  children: null,
};

export type SuccessOverlayVariant =
  | 'loading'
  | 'success'
  | 'cancelled'
  | 'unknown';

export interface SuccessOverlayProps {
  message: string;
  variant: SuccessOverlayVariant;
  subMessage?: string;
  link?: string;
  buttonText?: string;
  onClick?: () => unknown;
  buttonClassName?: string;
}

const SuccessOverlay = ({
  variant,
  message,
  subMessage,
  link,
  onClick,
  buttonText,
  buttonClassName,
}: SuccessOverlayProps) => (
  <div className="flex h-fit -mb-6 md:mb-0 md:h-full">
    <div className="flex flex-col flex-1 w-full h-full items-center justify-center">
      <div className="flex flex-col flex-1 md:flex-none text-center max-w-100 my-auto">
        <div className="p-4 md:8p-10 md:pb-0 my-auto md:my-0">
          {variant === 'success' && (
            <Icon
              icon="check-circle"
              className="text-5xl text-purple-200 mx-auto mb-8"
              width={75}
              height={75}
            />
          )}
          {variant === 'cancelled' && (
            <Icon
              icon="close"
              className="text-5xl text-red-200 mx-auto mb-8"
              width={75}
              height={75}
            />
          )}
          {variant === 'unknown' && (
            <Icon
              icon="error"
              className="text-5xl text-orange-200 mx-auto mb-8"
              width={75}
              height={75}
            />
          )}
          {variant === 'loading' && (
            <LoadingSpinner
              size={50}
              stroke="purple-400"
              className="mx-auto mb-6"
            />
          )}
          <div className="mb-8">
            <h1 className="text-24-28-em text-3xl">{message}</h1>
            {subMessage && (
              <p className="text-16-24-em text-neutral-600 mt-4">
                {subMessage}
              </p>
            )}
          </div>
        </div>
        {buttonText && (
          <ButtonWrapper link={link}>
            <Button.Text
              id="success-overlay-button"
              onClick={onClick}
              label={buttonText}
              icon="arrow-right"
              className={buttonClassName}
            />
          </ButtonWrapper>
        )}
      </div>
    </div>
  </div>
);

SuccessOverlay.defaultProps = {
  subMessage: null,
  link: null,
  buttonText: null,
  onClick: undefined,
  buttonClassName: undefined,
};

export default SuccessOverlay;
